// import { legacy_createStore as createStore  } from 'redux';
// import reducers from './reducers/Index';
// const store = createStore(reducers);

// export default store;

import { configureStore } from "@reduxjs/toolkit";
import ReduxReducer from "./reducers/FetchReducer";

const Store = configureStore({
    reducer: {
        allData: ReduxReducer,
    }
});

export default Store;
